<template>
  <noa-space-layout v-if="userType === UserType.TECHNICAL_USER" />
  <base-layout v-else>
    <template
      v-if="userType === UserType.CUSTOMER_SUPPORT"
      #items
    >
      <nav-item
        icon="smart"
        :route="{ name: RouteNames.API_CLIENTS_PARENT }"
      />
      <nav-item
        icon="chart"
        :route="{ name: RouteNames.AUDIT_LOG }"
      />
    </template>
  </base-layout>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { RouteNames } from '@/router/routeNames';
import { BaseLayout, NavItem, NoaSpaceLayout } from '@/shared/layouts/base';
import { UserType } from '@/shared/services/user/models';
import { useUserContextStore } from '@/shared/user-context';

const $userContextStore = useUserContextStore();
const userType = computed(() => $userContextStore.userType);
</script>
